import { Controller } from "stimulus"
import Litepicker from "litepicker";
import 'litepicker/dist/plugins/keyboardnav';
import 'litepicker/dist/plugins/mobilefriendly';
import 'litepicker/dist/plugins/ranges';
import {DataTable} from "simple-datatables"

export default class extends Controller {
  static targets = ["reportFilterForm", "hiddenStartDateInput", "hiddenEndDateInput"]

  initialize() {
    this.setupFlatpickr();

    this.setupDownloadLink();
    this.dataTable = new DataTable("#reportTable", {
      perPage: 15,
      perPageSelect: false,
      labels: {
        noRows: "No guests found for date range given",
        info: "Showing {start} to {end} of {rows} guests"
      }
    });
    this.ourSearchBar = document.getElementById('reportSearchBar');
    this.simpleDatatableSearch = document.getElementsByClassName('dataTable-input')[0];
    this.setupDataTableSearch();
    this.addSortButtonLabels();
    this.addPaginationLabels();
  }

  addSortButtonLabels() {
    //for screenreaders to announce the sort column
    let sortLinks = document.querySelectorAll('.dataTable-sorter');
    sortLinks.forEach((link, index) => {
      link.setAttribute('aria-label', `Sort column ${index + 1}`);
    });
  }

  addPaginationLabels() {
    //for screenreaders to announce the page number in the table
    let paginationLinks = document.querySelectorAll('.dataTable-pagination a');
    paginationLinks.forEach((link, index) => {
      link.setAttribute('aria-label', `Go to page ${index + 1}`);
    });
  }

  setupFlatpickr() {
    let self=this;
    //Date picker with good accessibility support for screen readers
    flatpickr('#datepicker', {
      mode: "range",
      altInput: true,
      altFormat: "J F Y",
      dateFormat: "Y-m-d",
      defaultDate: this.getPickerDates(),
      onChange: function(selectedDates, dateStr, instance) {
        if (selectedDates.length == 2) {
          // Both dates in the range have been selected
          self.setDateRange(selectedDates[0], selectedDates[1]);
          console.log(selectedDates, dateStr);
        }
      },
      onReady: function(dateObj, dateStr, instance) {
        const input = instance.altInput || instance.input;
        input.setAttribute('aria-label', 'Select date range for the report');
      }
    });
  }

  setupDownloadLink() {
    // Set url to maintain date and filter params
    let url = new URL(location.href);
    url.searchParams.set('format', 'csv');
    document.getElementById('downloadReport').href += url.search;
  }

  setDateRange(date1, date2){
    // Replace params to maintain type filter query string
    let url = new URL(location.href);
    url.searchParams.set('format', 'html');
    url.searchParams.set('start', (date1.getTime()/1000).toString());
    url.searchParams.set('end', (date2.getTime()/1000).toString());
    window.location.href = url.href;
  }

  submitReportFilter(event){
    // Set date to maintain date filter when sending form
    let start = this.getPickerDates()[0].getTime()/1000;
    let end = this.getPickerDates()[1].getTime()/1000;
    this.hiddenStartDateInputTarget.value = start;
    this.hiddenEndDateInputTarget.value = end;
    event.target.submit();
  }

  getPickerDates(){
   let searchParams = new URLSearchParams(window.location.search);
   let start = searchParams.get('start')
   let end = searchParams.get('end')
   if (start && end) {
     return [new Date(start * 1000), new Date(end * 1000)]
   } else {
     let date = new Date();
     return [new Date(date.getFullYear(), date.getMonth(), 1),
             new Date(date.getFullYear(), date.getMonth() + 1, 0)]
   }
  }

  setupDataTableSearch(){
    this.ourSearchBar.addEventListener('keyup', (e) => {
      this.simpleDatatableSearch.value = this.ourSearchBar.value;
      this.simpleDatatableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
  }
}
